// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gg-0";